import { InsuranceCoverage } from "./mislaka_xml_insurence_models";
import { ManagementFeeDetails, PensionData, PensionFundDetails, RetirementSavingsByAge } from "./mislaka_xml_pension_models";
import { User, UserPrivacyData } from "./user";
import { MortgageDetails } from "./mortgage/mortgage";

export interface DocumentHeader {
    document_type: string;
    version_number: number;
    execution_date: string;
    environment_code: string;
    document_direction: string;
    sender_code: string;
    sender_name: string;
    handler_code: string;
    handler_name: string;
    transfer_identifier: string;
    document_number: number;
  }
  
  export interface ProducerContact {
    handler_code: string;
    handler_name: string;
  }
  
  export interface Employer {
    employer_code: string;
    employer_name: string;
  }
  
  export enum Gender {
    MALE = '1',
    FEMALE = '2',
    UNKNOWN = '3',
  }

  export interface Client {
    client_code: number;
    client_name: string;
    client_id: string;
    previous_last_name?: string; // Default: ''
    last_name?: string;          // Default: ''
    gender?: string;             // Enum Gender (1=זכר, 2=נקבה, 3=לא ידוע)
    birth_date?: string | null;  // Optional
    marital_status?: number;     // Default: 5 (Enum MaritalStatus)
    country?: string;            // Default: ''
    city?: string;               // Default: ''
    city_code?: string;          // Default: ''
    street?: string;             // Default: ''
    house_number?: string;       // Default: ''
    entrance_number?: string;    // Default: ''
    apartment_number?: string;   // Default: ''
    postal_code?: string;        // Default: ''
    telephone?: string;          // Default: ''
    cellular?: string;           // Default: ''
    email?: string;              // Default: ''
    notes?: string;              // Default: ''
    children_count?: number;     // Default: 0
  }
  
  export enum MaritalStatus {
    NOT_RELEVANT = 0,
    SINGLE = 1,
    MARRIED = 2,
    DIVORCED = 3,
    WIDOWED = 4,
    UNKNOWN = 5,
    COHABITATING = 6,
  }
  export interface InvestmentPathDetail {
    accumulated_amount: number; // סכום הצבירה במסלול
    path_name: string; // שם המסלול
    path_code: number; // קוד מסלול השקעה
    management_fee_on_deposit: number; // שיעור דמי ניהול על הפקדה
    management_fee_on_savings: number; // שיעור דמי ניהול על חסכון
    other_management_fees?: number; // דמי ניהול אחרים (ייתכן null)
    net_return?: number; // תשואה נטו (ייתכן null)

    path_type_code?: number;  // קוד סוג מסלול (KOD-SUG-MASLUL) PathTypeCode
    contribution_type_code?: number;  // קוד סוג הפרשה (KOD-SUG-HAFRASHA) ContributionType
    deposit_percentage?: number;  // אחוז ההפקדה השוטפת המופנה למסלול ההשקעה(ACHUZ-HAFKADA-LEHASHKAA)
    expected_annual_cost_rate?: number;  // שיעור עלות שנתית צפויה (SHIUR-ALUT-SHNATIT-ZPUIA-LMSLUL-HASHKAH)
  }
  
  export enum ProductType {
    LIFE_INSURANCE_SAVINGS = 1, // פוליסת ביטוח חיים משולב חיסכון
    PENSION_FUND = 2, // קרן פנסיה
    PROVIDENT_FUND = 3, // קופת גמל
    EDUCATION_FUND = 4, // קרן השתלמות
    PURE_SAVINGS_POLICY = 5, // פוליסת חיסכון טהור
    PURE_RISK_POLICY = 6, // פוליסת סיכון טהור (ריסק מוות ו/או פוליסת אכ""ע SA)
    MORTGAGE_LIFE_INSURANCE = 7, // ביטוח חיים משכנתא
    COLLECTIVE_RISK_POLICY = 8, // פוליסת סיכון טהור קולקטיב
    INVESTMENT_PROVIDENT_FUND = 9, // קופת גמל להשקעה
    CHILD_SAVINGS = 10, // חיסכון לכל ילד
    LIFE_INSURANCE_AND_PURE_SAVINGS = 15, // פוליסות שהונפקו החל משנת 2004 - משותף לביטוח חיים חיסכון ולחיסכון טהור
  }
  export enum AdjustedProductType {
    LIFE_INSURANCE_SAVINGS = 1, // פוליסת ביטוח חיים משולב חיסכון
    PENSION_FUND = 2, // קרן פנסיה
    PROVIDENT_FUND = 3, // קופת גמל
    EDUCATION_FUND = 4, // קרן השתלמות
    PURE_SAVINGS_POLICY = 5, // פוליסת חיסכון טהור
    PURE_RISK_POLICY = 6, // פוליסת סיכון טהור (ריסק מוות ו/או פוליסת אכ""ע SA)
    MORTGAGE_LIFE_INSURANCE = 7, // ביטוח חיים משכנתא
    COLLECTIVE_RISK_POLICY = 8, // פוליסת סיכון טהור קולקטיב
    INVESTMENT_PROVIDENT_FUND = 9, // קופת גמל להשקעה
    CHILD_SAVINGS = 10, // חיסכון לכל ילד

    // חדשים בלבד:
    ACTIVE_MANAGERS_INSURANCE = 111, // ביטוח מנהלים פעיל -> קרן פנסיה מנהלים וביטוח
    INACTIVE_MANAGERS_INSURANCE = 112, // ביטוח מנהלים לא פעיל -> קרן פנסיה מנהלים ללא ביטוח
    MANDATORY_PENSION_FUND = 121, // קרן פנסיה חובה
    SUPPLEMENTARY_PENSION_FUND = 122, // קרן פנסיה משלימה
    BASIC_PENSION_FUND = 123, // קרן פנסיה יסוד
    OLD_COMPREHENSIVE_PENSION = 124, // קרן פנסיה מקיפה ותיקה
    OLD_BASIC_PENSION = 125, // קרן פנסיה בסיסית ותיקה
    CAPITAL_PROVIDENT_FUND = 131, // קופת גמל הונית
    PENSION_PROVIDENT_FUND = 132, // קופת גמל פנסיונית
    COMBINED_PROVIDENT_FUND = 133 // קופת גמל הונית ופנסיונית
  }
  
  export enum PolicyStatus {
    ACTIVE = 1, // פעיל
    NOT_ACTIVE = 2, // מוקפא/מסולק/לא פעיל
    CANCELED = 3, // מבוטל
    TEMPORARY_RISK = 4, // ריסק זמני
    CLAIM = 5, // בתביעה
    DEPOSIT_BLOCKED = 6, // חסום להפקדות (רק לגמל)
    PERIOD_ENDED = 7, // תום תקופה
    AUTOMATIC_TEMPORARY_RISK = 8, // ריסק זמני אוטומטי
    INSURANCE_COVERAGE_MAINTAINED = 9, // שמירת כיסוי ביטוחי
    NOT_RELEVANT = 10, // לא רלוונטי
  }
  
  export enum DepositType {
    CURRENT = 1, // שוטפת
    ONE_TIME = 2, // חד פעמית
    FUNDS_TRANSFER = 3, // ניוד כספים
  }
  
  export enum DepositCode {
    CAPITAL = 1, // הון
    PENSION_PAYING = 2, // קצבה משלמת
    PENSION_NON_PAYING = 3, // קצבה לא משלמת
    CUSTOMER_CHOICE = 4, // נתון לבחירת הלקוח (עד שנת 2000)
    NO_SAVINGS_POLICY = 5, // פוליסות ללא חיסכון
  }
  export enum PathTypeCode {
    ACCUMULATED = 1, // מצבירה
    CURRENT = 2,     // שוטף
  }

  export enum ContributionType {
    COMPENSATION = 1, // פיצויים
    EMPLOYEE_CONTRIBUTIONS = 2, // תגמולים עובד
    EMPLOYER_CONTRIBUTIONS = 3, // תגמולים מעביד
    EMPLOYER_CONTRIBUTIONS_47 = 4, // תגמולים47
    DISABILITY_INSURANCE = 5, // אבדן כושר עבודה
    OTHER_EMPLOYEE = 6, // שונות עובד
    OTHER_EMPLOYER = 7, // שונות מעביד
    EDUCATION_EMPLOYEE = 8, // קה"ש עובד
    EDUCATION_EMPLOYER = 9, // קה"ש מעביד
    PRIVATE_CONTRIBUTIONS = 10, // תגמולים פרט
    RISK_DEATH = 11, // ריסק מוות (ללא חסכון)
    CHILD_SAVINGS = 12, // חיסכון לכל ילד
  }
  
  export enum DepositorType {
    EMPLOYEE = 1, // עובד
    CURRENT_EMPLOYER = 2, // מעסיק נוכחי
    PREVIOUS_EMPLOYER = 3, // מעסיק קודם
    NATIONAL_INSURANCE = 4, // ביטוח לאומי
    PARENT_DEPOSIT = 5, // הפקדת הורים
    MOVING_FUNDS = 6 // ניוד כספים
  }

// תקרות הפקדה תואמות (Liquidity Matched Deposit Cap)
export enum LiquidityMatchedDepositCap {
  UP_TO_CAP = 1,                           // עד התקרה
  ABOVE_CAP = 2,                           // מעל התקרה
  NA = 0,                                  // לא זמין
}

// רכיבי יתרה (Liquidity Balance Components)
export enum LiquidityBalanceComponent {
  COMPENSATION = 1,                        // פיצויים
  EMPLOYEE_PENSIONS = 2,                   // תגמולים עובד
  EMPLOYER_PENSIONS = 3,                   // תגמולים מעביד
  PENSIONS_47 = 4,                         // תגמולים 47
  DISABILITY_LOSS = 5,                     // אבדן כושר עבודה
  MISC_EMPLOYEE = 6,                       // שונות עובד
  MISC_EMPLOYER = 7,                       // שונות מעביד
  SAVINGS_EMPLOYEE = 8,                    // קה"ש עובד
  SAVINGS_EMPLOYER = 9,                    // קה"ש מעביד
  PRIVATE_PENSIONS = 10,                   // תגמולים פרט
  RISK_DEATH_NO_SAVINGS = 11,              // ריסק מוות (ללא חסכון)
  SAVINGS_FOR_CHILD = 12,                  // חיסכון לכל ילד
}

// סוגי יתרה (Liquidity Period Balance Types)
export enum LiquidityPeriodBalanceType {
  CAPITAL = 1,                             // הון
  PAYING_PENSION = 2,                      // קצבה משלמת
  NON_PAYING_PENSION = 3,                  // קצבה לא משלמת
  CUSTOMER_CHOICE = 4,                     // נתון לבחירת הלקוח
}

export enum PowerOfAttorneyExistence {
  YES = 1, // כן
  NO = 2   // לא
}

export enum IdentificationType {
  INDIVIDUAL = 1, // פרטי
  CORPORATION = 2 // תאגיד
}

export enum RepresentativeType {
  AGENT = 1,          // סוכן
  ADVISOR = 2,        // יועץ
  GUARDIAN = 3,       // אפוטרופוס
  OTHER = 4           // אחר
}
export interface RepresentativeInfo {
  power_of_attorney_exists: number; //PowerOfAttorneyExistence האם קיים מיופה כוח (KAYAM-MEYUPE-KOACH) Enum: YesNo
  identification_type: number; // IdentificationTypeסוג זיהוי (SUG-ZIHUY) Enum: IdentificationType
  representative_type: number; //RepresentativeType; // סוג מיופה כוח (MEYOPE-ZIHUY) Enum: RepresentativeType
  authorization_for_action?: number; //PowerOfAttorneyExistence הרשאה לביצוע פעולה (HARSHAA-LEBITZUAE-PEULA)
  identification_number?: string; // מספר זיהוי (MISPAR-ZIHUY)
  appointment_date?: string; // תאריך מינוי סוכן (TAARICH-MINUY-SOCHEN)
  expire_appointment_date?: string; // תאריך מינוי סוכן (TAARICH-MINUY-SOCHEN)
  representative_name?: string; // שם מיופה כוח (SHEM-MEYUPE-KOACH)
}
export enum DepositTypeCode {
  Capital = 1, // הון
  PensionPaying = 2, // קצבה משלמת
  PensionNonPaying = 3, // קצבה לא משלמת
  CustomerChoice = 4, // נתון לבחירת הלקוח (רלוונטי לכספים שהופקדו עד שנת 2000)
  NoSavings = 5 // הפקדות לפוליסות ללא חיסכון
}
export enum DepositTypeCode {
  CAPITAL = 1, // הון
  PENSION_PAYING = 2, // קצבה משלמת
  PENSION_NON_PAYING = 3, // קצבה לא משלמת
  CUSTOMER_CHOICE = 4, // נתון לבחירת הלקוח (רלוונטי לכספים שהופקדו עד שנת 2000)
  NO_SAVINGS = 5 // הפקדות לפוליסות ללא חיסכון
}
export enum PayerIdType {
  CHP = 1,                // ח.פ
  CHZ = 2,                // ח.צ
  TEUDAT_ZEHUT = 3,       // ת.ז
  PASSPORT = 4,           // דרכון
  CORPORATION = 5,        // תאגיד
  OSEK_MORSHE = 6,        // עוסק מורשה
  EMPLOYER_CODE = 7,      // מספר מעסיק אצל היצרן
  UNKNOWN = 8             // לא ידוע
}

export enum PaymentMethod {
  BANK_TRANSFER = 1,
  DIRECT_DEBIT = 2,
  CREDIT_CARD = 3,
  CASH = 4,
  OTHER = 5,
  CHECK = 6
}

export enum PaymentFrequency {
  YEARLY = 1,         // שנתי
  SEMI_YEARLY = 2,    // חצי-שנתי
  QUARTERLY = 3,      // רבעוני
  MONTHLY = 4,        // חודשי
  ONE_TIME = 5        // חד פעמי
}

export enum IndexationMethod {
  TO_SALARY = 1,
  CPI = 2,
  WEIGHTED_COLLECTION_INDEX = 3,
  HALF_YEARLY = 4,
  HALF_YEARLY_ADJUSTED = 5,
  NOT_INDEXED = 6,
  USD = 7,
  KNOWN_INDEX_FIRST = 8,
  KNOWN_INDEX_LAST = 9,
  COST_OF_LIVING_WITH_CEILING = 10,
  COST_OF_LIVING_NO_CEILING = 11
}

  export interface DepositDetail {
    deposit_date: string;
    deposit_type_code: number; //DepositTypeCode
    contribution_type: number;
    depositor_type: number;
    deposit_amount_paid: number;
    salary_base: number;
    salary_month: string;  //'202502'
    payment_period: number; //202503
    employer_name?: string; // שם המעסיק (אופציונלי)
    deposit_rate?: number;  // אחוז הפרשה (אופציונלי)
    adjusted_product_type?: number; // AdjustedProductType
  }
  export interface LastDepositSummary {
      reference_month: string; // תאריך הפקדה אחרון YYYYMM
      total_last_deposit: number; // סה"כ הפקדה אחרונה
      saving_a: number; // חיסכון עדיף א'
      saving_b: number; // חיסכון עדיף ב'
      value_date: string; // תאריך ערך הפקדה YYYYMMDD או "0"
      deposit_type: number; // סוג הפקדה: 1/2/3
      total_last_saving_deposit: number; // סה"כ לחיסכון נטו
  }
  export interface DepositCollectionDetails {
    payer_name: string;
    payer_id_type?: number; // PayerIdType
    payer_id_number: string;
    payment_method?: number; // PaymentMethod
    payment_frequency?: number;
    reference_month?: number;
    payment_day_in_month?: number;
    indexation_method?: number; // IndexationMethod
    sub_yearly_percentage?: number;
  }
  export interface FundTransferDetails extends DepositDetail {
    payment_period_code: string; // 'ZMAN-PERAON'
    transferring_fund_id: number; // 'KOD-MEZAHE-KOPA-MAAVIRA'
    transferring_fund_name: string; // 'SHEM-KOPA-MAAVIRA'
    transferring_corporation:string
    fixing_date: string; // 'MOED-KOVEA-NIUD'
  }
  export enum InterestType {
    FIXED = 1, // ריבית קבועה
    VARIABLE = 2, // ריבית משתנה
  }
  // LinkageType
export enum LinkageType {
  NONE = 1, // ללא הצמדה
  MONTHLY_INDEX = 2, // מדד חודשי
  SEMI_ANNUAL_INDEX = 3, // מדד חצי שנתי
  OTHER = 4, // אחר
}

// RepaymentFrequency
export enum RepaymentFrequency {
  MONTHLY = 1, // חודשי
  QUARTERLY = 2, // רבעוני
  SEMI_ANNUAL = 3, // חצי שנתי
  ANNUAL = 4, // שנתי
  OTHER = 5, // אחר
}

export enum LoanToPolicyRatio { // יחס הלוואה לפוליסה/מבוטח
    SPECIFIC_POLICY = 1,
    ALL_POLICIES = 2
}

// RepaymentType
export enum RepaymentType {
  SPITZER = 1, // שפיצר
  CURRENT_INTEREST = 2, // ריבית שוטפת
}

  export interface LoanDetails {
    loan_in_product?: number; // האם קיימת הלוואה במוצר? (LoanInProduct)
    loan_to_policy_ratio?: number; // יחס הלוואה לפוליסה/מבוטח (LoanToPolicyRatio)
    loan_serial_number?: number; // מס' סידורי של ההלוואה
    loan_amount?: number; // סכום ההלוואה
    loan_start_date?: string; // מועד קבלת ההלוואה (ISO format: YYYY-MM-DD)
    loan_end_date?: string; // תאריך סיום ההלוואה (ISO format: YYYY-MM-DD)
    loan_balance?: number; // יתרת ההלוואה לתשלום
    loan_period_months?: number; // תקופת החזר ההלוואה בחודשים
    interest_rate?: number; // ריבית
    interest_type?: number; // סוג ריבית (InterestType)
    linkage_type?: number; // סוג הצמדה (LinkageType)
    repayment_frequency?: number; // תדירות החזר ההלוואה (RepaymentFrequency)
    repayment_type?: number; // סוג החזר (RepaymentType)
    periodic_repayment_amount?: number; // סכום ההחזר התקופתי
  }
export enum DebtType {
  SEVERANCE = 1, // חוב פיצויים
  CONTRIBUTIONS = 2, // חוב תגמולים
  STUDY_FUND = 3, // חוב הפקדות לקרן השתלמות
  INSURANCE_PREMIUM = 4, // דמי ביטוח בפיגור
  BOTH = 5, // פיצויים + תגמולים
  OTHER = 6 // אחר
}

  export interface DebtDetail {
    exists: number;
    start_date: string;
    corrected_start_date: string;
    months_count: number;
    debt_type: number;  // DebtType
    total_debt: number;
    non_allocated_funds: number;
  }

export interface YearDepositSummaryDTO {
    total_employee_contributions?: number;
    total_employer_contributions?: number;
    total_compensation_contributions?: number;
    // נתוני יתרות בסוף שנה
    end_of_year_balance?: number;
    surrender_value?: number;
    paid_up_value?: number;
    actuarial_adjustment?: number;
}
  export enum LegalLimitStatus {
    NO = 0,                   // ללא שיעבוד או עיקול
    LIEN = 11,                // שיעבוד בלבד
    FORECLOSURE = 12,         // עיקול בלבד
    LIEN_AND_FORECLOSURE = 13 // שיעבוד ועיקול
  }

  export interface PolicyOrAccount {
    policy_number: string; // מספר פוליסה
    status: number; // PolicyStatus - סטטוס הפוליסה
    update_date?: string; // תאריך עדכון
    program_name?: string; // שם התוכנית
    join_date?: string; // תאריך הצטרפות ראשון
    agent_id_for_producer?: string; // מספר סוכן ביצרן
    product_join_date?: string; // תאריך הצטרפות למוצר
    plan_or_account_type?: number; // סוג תוכנית או חשבון
    policy_type_category?: number; // סוג תוכנית או חשבון
    legal_limit_status?: LegalLimitStatus; // סטטוס שיעבוד/עיקול
    pension_data?: PensionData
    accumulated_savings?: AccumulatedSavings[]; // יתרה צפויה
    net_return_rate?: number; // שיעור תשואה נטו
    net_return_amount?: number; //  תשואה נטו
    investment_paths: InvestmentPathDetail[]; // רשימת מסלולי השקעה
    deposits?: DepositDetail[]; // רשימת הפקדות
    last_deposit_summary?: LastDepositSummary[]; // סיכום הפקדה אחרונה
    funds_transfer?: FundTransferDetails[]; // רשימת הפקדות
    liquidity_details?: LiquidityDetails[]; // פרטי נזילות
    liquidity_summaries?: LiquiditySummary[]; // סיכום נזילות
    loan_details?: LoanDetails[]; // פרטי הלוואות
    mortgage_details?: MortgageDetails[]; // פרטי משכנתאות
    fund_actions?: FundAction[]; // פעולות קרן
    retirement_savings_by_age?: RetirementSavingsByAge[]; // יתרות לפי גיל פרישה
    pension_fund_details?: PensionFundDetails[]; // פרטי קופות פנסיה
    management_fee_details?: ManagementFeeDetails[]; // פרטי דמי ניהול
    representative_info?: RepresentativeInfo[]; // פרטי סוכן
    insurence_coverages?: InsuranceCoverage[];
    deposit_collection_details?: DepositCollectionDetails[];
    year_deposit_summary?: YearDepositSummaryDTO[];
    debt_details?: DebtDetail[]; // פרטי חובות
  }
  
  
  
  export interface ProductDetails {
    producer_code: string;
    handler_code: string;
    product_type: number; // ProductType
    adjusted_product_type?: number; // AdjustedProductType
  }
  
  export interface Product {
    details?: ProductDetails;
    employer?: Employer; // פרטי המעסיק
    client?: Client; // פרטי הלקוח
    policies_or_accounts: PolicyOrAccount[];
  }
  
  export interface Mimshak {
    document_header?: DocumentHeader;
    producer_contact?: ProducerContact;
    products: Product[];
  }
  
  // DTO עבור תוצאות עיבוד קובץ
// export interface FileProcessingResultDTO {
//   filename: string;
//   status: "success" | "failure" | "ignored";
//   mimshaks?: Mimshak[]; // רשימה של אובייקטי Mimshak במקרה של הצלחה
//   error?: string; // הודעת שגיאה במקרה של כשלון
// }
// export interface ProcessedClient {
//   user: User;
//   user_privacy_data: UserPrivacyData; // אם יש מבנה קבוע, אפשר להחליף ב-interface מתאים
// }

// export interface ProcessedFileResult {
//   preview_results: FileProcessingResultDTO[];
//   processed_clients: ProcessedClient[];
// }


export interface LiquidityDetails {
  start_period_code: number; // LiquidityLayerScopeCode
  matched_deposit_cap: number; // LiquidityMatchedDepositCap
  balance_component: number; // LiquidityBalanceComponent
  balance_type: number; // LiquidityPeriodBalanceType
  balance_amount: number;
}

export interface LiquiditySummary{
    liquidity_date?: string;
    liquidity_amount: number;
}

export interface AccumulatedSavings {
  savings_type_code: number; // KOD-SUG-ITRA //LiquidityPeriodBalanceType
  deposit_type_code: number; // KOD-SUG-HAFRASHA //PolicyTypeCategory
  total_savings: number; // TOTAL-CHISACHON-MTZBR
  total_redemption_value: number; // TOTAL-ERKEI-PIDION
}

export enum PolicyTypeCategory {
  CLASSIC = 1, // קלאסי
  PREFERRED = 2, // עדיף
  POST_2004 = 3, // פוליסות משנת 2004 ואילך
  RISK_OR_DISABILITY = 4, // ריסק ואו אכ"ע
}

export enum ActionTypeCode {
  WITHDRAWAL = 1, // משיכה
  TRANSFER = 2,   // ניוד
  CORRECTION = 3, // תיקון (כגון החזר דמי ניהול, החזר פרמיה)
}

export enum ActionBalanceActionComponent {
  COMPENSATION = 1, // פיצויים
  EMPLOYEE_PENSIONS = 2, // תגמולים עובד
  EMPLOYER_PENSIONS = 3, // תגמולים מעביד
  PENSIONS_47 = 4, // תגמולים 47
  MISC_EMPLOYEE = 6, // שונות עובד
  MISC_EMPLOYER = 7, // שונות מעביד
  SAVINGS_EMPLOYEE = 8, // קה"ש עובד
  SAVINGS_EMPLOYER = 9, // קה"ש מעביד
  PRIVATE_PENSIONS = 10, // תגמולים פרט
  PREMIUM_REFUND = 11, // החזר פרמיה
  MANAGEMENT_FEE_REFUND = 12, // החזר דמי ניהול
  OTHER = 13, // אחר
  CHILD_SAVINGS = 14, // חיסכון לכל ילד
}

export enum TransferRequestType {
  MEMBER_REQUEST = 1,            // בקשת העמית (להעברה חלקית של הכספים)
  GARNISHMENT = 2,               // עיקול בקופה המעבירה (בהעברה חלקית)
  COLLATERAL = 3,                // שעבוד בקופה המעבירה (בהעברה חלקית)
  EMPLOYER_DEBT_REPAYMENT = 4,    // פרעון חוב מעסיק
  OTHER = 5,                     // אחר
  NOT_RELEVANT = 6               // לא רלוונטי (מיועד לשימוש בגין העברה מלאה)
}

export interface FundAction {
  action_type_code: number; // קוד סוג פעולה (KOD-SUG-PEULA)  ActionTypeCode
  balance_component: number; // רכיב נמשך/ניוד (RACHIV-NIMSHACH-NUYAD)
  withdrawal_amount: number; // סכום משיכה/ניוד (SCHOOM-MESHICHA-NIUD)
  execution_date: string; // תאריך ביצוע (TAARICH-BIZOA)
  value_date: string; // תאריך ערך (TAARICH-ERECH)
  penalty_amount?: number | null; // קנס משיכה/ניוד (KNAS-MESHICHA-NIUD)
  receiving_fund_code?: string | null; // קוד קופה מקבלת (KOD-MEZAHE-KOPA-MEKABELET)
  receiving_handler_code?: string | null; 
  receiving_fund_name?: string | null; // שם קופה מקבלת (SHEM-KOPA-MEKABELET)
  transfer_reason?: number | null; // עילת העברה (ILAT-HAAVARA) TransferRequestType 
  determining_date?: string | null; // מועד קובע (MOED-KOVEA)
}


export enum LiquidityLayerScopeCode {
  UNTIL_BUDGETARY_LAW_1997_2000 = 1, // עד חוק ההסדרים (1997 2000)
  AFTER_BUDGETARY_LAW_1997_2000 = 2, // לאחר חוק ההסדרים (1997 2000)
  UNTIL_31_12_2004 = 3, // עד 31.12.2004
  UNTIL_31_12_2005 = 4, // עד 31.12.2005
  FROM_01_01_2005_TO_31_12_2007 = 5, // מ-01.01.2005 עד 31.12.2007
  FROM_01_01_2006_TO_31_12_2007 = 6, // מ-01.01.2006 עד 31.12.2007
  FROM_01_01_2008 = 7, // מ- 01.01.2008
  UNTIL_31_12_2002 = 8, // עד 31.12.2002
  COMPENSATION = 9, // פיצויים
  MANUAL_CALCULATION_REQUIRED = 10, // נדרש חישוב ידני
  FROM_01_01_2003_TO_31_12_2005 = 11, // מ-01.01.2003 ועד 31.12.2005
  FROM_01_01_2006_TO_31_12_2011 = 12, // מ-01.01.2006 ועד 31.12.2011
  FROM_01_01_2012 = 13, // החל מ - 01.01.2012
  NEW_ACCOUNT = 14, // חשבון חדש
}

